/**
 * @generated SignedSource<<ff4b3f0301d5f1a0e232e3c973dd7c8f>>
 * @relayHash 877c8e0c7a6d12a1368dc7d0f0dc16bc
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/545.0.0-2026-02-04T17:00:32.354Z/commitFollowSearchMutation

import { ConcreteRequest } from 'relay-runtime';
export type FavoriteAction = "ADD" | "REMOVE" | "%future added value";
export type FavoritePageInput = {
  action: FavoriteAction;
  clientMutationId?: string | null;
  favoriteId?: string | null;
  name?: string | null;
  page: string;
  query?: string | null;
  type: string;
  userId: string;
};
export type commitFollowSearchMutation$variables = {
  followSearchUriRef?: string | null;
  input: FavoritePageInput;
};
export type commitFollowSearchMutation$data = {
  readonly favoritePage: {
    readonly user: {
      readonly favorites: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly serviceId: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type commitFollowSearchMutation = {
  response: commitFollowSearchMutation$data;
  variables: commitFollowSearchMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "followSearchUriRef"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "items": [
      {
        "kind": "Variable",
        "name": "pages.0",
        "variableName": "followSearchUriRef"
      }
    ],
    "kind": "ListValue",
    "name": "pages"
  },
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "SEARCH"
    ]
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "commitFollowSearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoritePagePayload",
        "kind": "LinkedField",
        "name": "favoritePage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "favoritesConnection",
                "kind": "LinkedField",
                "name": "favorites",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "commitFollowSearchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FavoritePagePayload",
        "kind": "LinkedField",
        "name": "favoritePage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v2/*: any*/),
                "concreteType": "favoritesConnection",
                "kind": "LinkedField",
                "name": "favorites",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "favoritesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Favorite",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/545.0.0-2026-02-04T17:00:32.354Z/commitFollowSearchMutation",
    "metadata": {},
    "name": "commitFollowSearchMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "27e59050ad4dbd25a863884c72c6ac28";

export default node;
